import React from 'react';
import classnames from 'classnames';
import PlainButtonOrLink from '../../Buttons/PlainButtonOrLink';
var Tab = function (_a) {
    var onClick = _a.onClick, biData = _a.biData, dataHook = _a.dataHook, isActive = _a.isActive, prefix = _a.prefix, label = _a.label, href = _a.href, postfix = _a.postfix, s = _a.viewClassNames, innerRef = _a.innerRef;
    return (React.createElement(PlainButtonOrLink, { className: classnames(s['tab'], isActive && s['active-tab']), href: href, onClick: onClick, biData: biData, "data-hook": dataHook, innerRef: innerRef },
        prefix && React.createElement("div", { className: s['prefix'] }, prefix),
        React.createElement("span", { className: s['label'] }, label),
        postfix));
};
Tab.displayName = 'Tab';
export default Tab;
//# sourceMappingURL=Tab.js.map